import { useEffect, useState } from 'react';

/** How long a load may take before a spinner is worth showing (#635). */
export const SPINNER_DELAY_MS = 150;

/**
 * `flag`, but only once it has stayed true for `delayMs`.
 *
 * For spinners: a load that finishes quickly shows nothing and its content
 * simply appears, rather than flashing a spinner for a few frames. A slow
 * one still gets its spinner. It turns false the moment `flag` does.
 */
export function useDelayedFlag(
  flag: boolean,
  delayMs: number = SPINNER_DELAY_MS
): boolean {
  const [delayed, setDelayed] = useState(false);

  useEffect(() => {
    if (!flag) {
      setDelayed(false);
      return;
    }
    const timer = setTimeout(() => setDelayed(true), delayMs);
    return () => clearTimeout(timer);
  }, [flag, delayMs]);

  return flag && delayed;
}
